import $ from "jquery";

class Player {
  constructor() {
    this.youtubeIframes = {};   // iframe elements keyed by id
    this.vimeoIframes  = {};
    this.currentPlayerId = null;

    this.setupYouTube();   // replaces injectYoutubeScript()
    this.setupVimeo();     // replaces injectVimeoScript()
  }

  /* ---------- YOUTUBE ---------- */

  setupYouTube() {
    const that = this;
    const ytIframes = $("iframe.video--youtube");

    if (!ytIframes.length) return;
    /* inline playback inside article / hero etc. (unchanged) */
    this.handleInlineVideo();

    /* full-screen / popup playback */
    $(".js-show-video--youtube").on("click", function () {
      const playBtn = $(this);
      that.handleVideoClasses();

      const videoId = playBtn.attr("data-video-id");
      that.currentPlayerId = videoId;

      const playerBlock    = playBtn.parents(".video-block__video-wrapper");
      const mainVideoBlock = playBtn.parents("section.video-block");
      const iframe         = $(`#${videoId}`);

      // lazy-load
      const dataSrc = iframe.data("src");
      if (dataSrc && iframe.attr("src") !== dataSrc) {
        iframe.attr("src", dataSrc);
      }

      $("body").addClass("has-video-popup");
      playerBlock.addClass("is-active");
      mainVideoBlock.addClass("video-active");

      that.youtubeIframes[videoId] = iframe[0];
      that.postToYouTube(videoId, "playVideo");
    });

    $(".js-hide-video--youtube").on("click", function () {
      const closeBtn       = $(this);
      const playerBlock    = closeBtn.parents(".video-block__video-wrapper");
      const mainVideoBlock = closeBtn.parents("section.video-block");
      const iframe         = playerBlock.find("iframe.video--youtube");
      const videoId        = iframe.attr("id");

      if (iframe.length) {
        that.postToYouTube(videoId, "pauseVideo");
      }

      $("body").removeClass("has-video-popup");
      playerBlock.removeClass("is-active");
      mainVideoBlock.removeClass("video-active");
    });
  }

  postToYouTube(id, func) {
    const iframe = this.youtubeIframes[id];
    if (!iframe) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: "command",
        func,
        args: [],
        id
      }),
      "*"
    );
  }

  /* ---------- VIMEO ---------- */

  setupVimeo() {
    const that = this;
    const vmIframes = $("iframe.video--vimeo");
    if (!vmIframes.length) return;

    $(".js-show-video--vimeo").on("click", function () {
      const playBtn = $(this);
      that.handleVideoClasses();

      const videoId = playBtn.attr("data-video-id");
      that.currentPlayerId = videoId;

      const playerBlock    = playBtn.parents(".video-block__video-wrapper");
      const mainVideoBlock = playBtn.parents("section.video-block");
      const iframe         = $(`#${videoId}`);

      $("body").addClass("has-video-popup");
      playerBlock.addClass("is-active");
      mainVideoBlock.addClass("video-active");

      that.vimeoIframes[videoId] = iframe[0];
      that.postToVimeo(videoId, "play");
    });

    $(".js-hide-video--vimeo").on("click", function () {
      const closeBtn       = $(this);
      const playerBlock    = closeBtn.parents(".video-block__video-wrapper");
      const mainVideoBlock = closeBtn.parents("section.video-block");
      const iframe         = playerBlock.find("iframe.video--vimeo");
      const videoId        = iframe.attr("id");

      if (iframe.length) {
        that.postToVimeo(videoId, "pause");
      }

      $("body").removeClass("has-video-popup");
      playerBlock.removeClass("is-active");
      mainVideoBlock.removeClass("video-active");
    });
  }

  postToVimeo(id, method) {
    const iframe = this.vimeoIframes[id];
    if (!iframe) return;
    iframe.contentWindow.postMessage({ method }, "*");
  }

  /* ---------- shared helpers (unchanged) ---------- */

  handleInlineVideo() {
    const that = this;
    $(".js-play-video").on("click", function () {
      const playBtn     = $(this);
      that.handleVideoClasses();
      const playerBlock = playBtn.parents(".video-block__video-wrapper");
      playerBlock.addClass("is-visible");
    });
  }

  handleVideoClasses() {
    const that = this;
    const activePlayers = $(".video-block__video-wrapper.is-visible, .video-block__video-wrapper.is-active");

    $.each(activePlayers, function () {
      const videoIframe = $(this).find("iframe");
      const id = videoIframe.attr("id");

      if (videoIframe.hasClass("video--youtube")) {
        that.postToYouTube(id, "pauseVideo");
      } else if (videoIframe.hasClass("video--vimeo")) {
        that.postToVimeo(id, "pause");
      }

      videoIframe.attr("src", "");
      $(this).removeClass("is-visible is-active");
    });
  }
}

new Player();
